import { render } from "./Crop.vue?vue&type=template&id=36dcd7d9&scoped=true&ts=true"
import script from "./Crop.vue?vue&type=script&lang=ts"
export * from "./Crop.vue?vue&type=script&lang=ts"

import "./Crop.vue?vue&type=style&index=0&id=36dcd7d9&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36dcd7d9"]])

export default __exports__